module.exports = __webpack_public_path__ + "media/images/icon-devices-769a495599085247c1613e5b9e7c33ae.svg";